export const REFUND_TYPE = {
  FULL: 0,
  PART: 1,
};
/**
 * promotion 类型
 */
const PROMOTION_TYPE = {
  PROMOTION_TYPE_PRODUCT_TOTAL: 1, // 商品小计
  PROMOTION_TYPE_PRICE_SPREAD: 2, // 消费补差价
  PROMOTION_TYPE_DISCOUNT: 3, // 优惠券
  PROMOTION_TYPE_DELIVERY: 4, // 配送费
  PROMOTION_TYPE_PLATFORM: 5, // 平台费
  PROMOTION_TYPE_TIPS: 6, // 小费， 只在订单详情页下发
  PROMOTION_TYPE_FIXED_TOTAL: 7, // 一口价总价
  PROMOTION_TYPE_PROMOTION_TOTAL: 8, // 具体优惠金额
  PROMOTION_TYPE_NON_MACKETING: -1, // 非营销字段
  PACKAGED_VOUCHER: 9, // 券包搭售

  PROMOTION_TYPE_NEW_USER_DISCOUNT: 11, // DISCOUNT
  PROMOTION_TYPE_NEW_USER_VOUCHER: 12, // VOUCHER
};

/// 订单公共的 URL
export const ORDER_URL = {
  LIST: 'v1/order/list',
  DETAIL: 'v1/order/detail',
  STATUTS: 'v1/order/status',
  ORDERPAY: 'v1/order/prePay',
  CANCEL: 'v1/order/cancel',
  CANCEL_V2: 'v1/order/cancel_v2',
  REFUNDCANCEL: 'v1/order/refund/cancel',
  RIDERINFO: 'v1/order/rider/info',
  IMButtonInfo: 'v1/order/list/button/info',
  RUSH: 'api/v1/order/rush',
  CONFIRM_PICKUP: 'v1/order/confirmPickup',
  MULTI_ORDER: 'dsp/order/detail/task/pop',
  POPUP_VIEW: 'v1/order/detail/popups',
  EVALUATE_SHOWN: 'v1/order/detail/popups/shown',
  ORDER_TASK: 'v1/start/task',
  BLOCK_RIDER: 'v1/order/user/updateRiderBlockStatus',
  CHECK_BLOCKED_LIST_LIMIT: 'v1/order/user/checkBlockedRiderLimitExceeded',
  CALL_COURIER_INFO: 'v1/callcourierinfo/query',
  CONFIRM_RETAIN: 'v1/order/retain',
  SUBMIT_ADDRESS: 'v1/addressSnapshot/submit'
};

export const STORE_REVIEW_URL = 'v1/order/store/review';

// 订单按钮类型
export const ORDERBTN_CODE = {
  CANCEL_ORDER: 1001, // 取消订单
  CONTACT_SHOP: 1002, // 致电商家
  PAY_NOW: 1003, // 立即支付
  APPLY_REFUND: 1004, // 申请退款
  CONTACT_RIDER: 1005, // 致电外送员
  BUY_AGAIN: 1006, // 再来一单
  EVALUATE: 1007, // 去评价
  REFUND_DETAIL: 1008, // 退款详情
  CANCEL_REFUND: 1009, // 取消退款
  CUSTOMER_SERVICE: 1010, // ?
  IM: 1011, // im
  REVIEW_EVALUATE: 1012, // 查看评价
  JUMP_TO_MAP: 1013, // 跳转到地图
  ORDER_RUSH: 1014, // 催单
  SHOP_IM: 1015, //商家IM
  TRACK_ORDER: 1016, // 追踪订单
  CONTACT_CS: 1017, //联系客服
  O_PAY_NOW: 5001, // 小象-立即支付
  O_BUY_AGAIN: 5002, // 小象-再来一单
  O_ORDER_DETAIL: 5003, // 小象-查看详情
  O_EVALUATE: 5004, // 小象-评价
  O_REVIEW_EVALUATE: 5005, // 小象-查看评价
  O_IM: 5006, // 小象-在线联系骑手
};

/// 订单状态页来源
export const ORDER_STATUS_SOURCE = {
  CONFIRM: '1',
  LIST: '2',
  REFUND_DETAIL: '3',
};

const OrderStatusPageCID = 'c_waimai_c_overseas_vl9a52s8';

export const RIDER_CONTACT_TYPE = {
  IM: '0',
  PHONE: '1',
};
export const ORDER_SOURCE = {
  main: 0,
  fixedPrice: 1,
};

export const FIXED_SUBCONTENT_TYPE = {
  platform: '1',
  delivery: '2',
};

export const ORDER_BIZLINE = {
  KFOOD: 'kfood',
  KEEMART: 'keemart',
  KDRONE: 'kdrone'
};

/**
 * 菜品标签类型
 */
enum SKU_TAG_TYPE {
  DISCOUNT_FOOD = 1, // 折扣菜享受优惠
  DISCOUNT_FOOD_FIXED_PRICE = 3, // 折扣菜享受优惠（一人食切换为折扣菜新增）
}

/**
 * 菜品活动类型
 */
enum LX_SKU_ACTIVITY_TYPE {
  FULL_REDUCTION = 0, // 满减
  FULL_DISCOUNT = 1, // 满折
  DISCOUNT_FOOD = 2, // 折扣
}

/**
 * 折扣菜信息
 */
enum LX_PROMO_DISHES_TYPE {
  NORMAL = 0, // 非折扣菜商品
  DISCOUNT_FOOD = 1, // 折扣菜商品
}

/**
 * 多任务弹窗类型
 */
enum MultiOrderDialogType {
  PARTICIPATE_REMINDER = 10, // 待领取任务,支付后参与提醒弹窗
  GET_COUPON = 20, // 任务进行中,支付后预达标提醒弹窗
  GET_COUPON_DONE = 20, // 任务已完成,支付后预达标提醒弹窗
}

/**
 * 优惠券使用状态
 */
enum USE_COUPON_STATUS {
  UNSELECT = 2, // 未选择优惠券
  UNAVAILABLE = 3, // 无可用优惠券
  SELECTED = 5, // 已选优惠券
}

/**
* 评价、查看评价页面来源信息
*/
enum EVALUATE_PAGE_SOURCE {
  ORDER_LIST = 1, // 订单列表页
  ORDER_STATUS = 2, // 订单详情页
}

/**
 * 大订单拆分多个包裹时，至少其中一个包裹被骑手接单
 */
const HAS_DELIVERY_GRAB = 1;
// 大订单
const BIG_ORDER_STATUS = 0;
// 非大订单
const NORMAL_ORDER_STATUS = 1;

/**
 * 催单状态
 */
enum ORDER_DELIVERY_STATUS {
  RIDER_TOO_CLOSE = 1, // 骑手过近
  FAR_FROM_TIMEOUT = 2, // 远为超时
  TIMEOUT_OCCURRED = 3, // 即将/已超时
  SEVERE_TIMEOUT = 4, // 严重超时
}

/**
 * 催单来源
 */
enum ORDER_RUSH_REFERER_TYPE {
  ORDER_STATUS = 1, // 订单详情页
  ORDER_REFUND = 2, // 订单申请退款页
}

//suggestedContactChannels
export const CONTACT_CHANNEL = {
  AUDIO: 'audio',
  PRIVACY_PHONE: 'privacyphone',
  PHONE: 'phone',
};

export {
  PROMOTION_TYPE, OrderStatusPageCID, SKU_TAG_TYPE, LX_SKU_ACTIVITY_TYPE, LX_PROMO_DISHES_TYPE,
  USE_COUPON_STATUS, EVALUATE_PAGE_SOURCE, MultiOrderDialogType,
  HAS_DELIVERY_GRAB, BIG_ORDER_STATUS, NORMAL_ORDER_STATUS, ORDER_DELIVERY_STATUS, ORDER_RUSH_REFERER_TYPE
};
